module.exports = __webpack_public_path__ + "static/55dd4b60.guide-shopify-account2.png";